import React from "react";

function Label({ label, children, ...otherProps }) {
  return (
    <>
      <div className="flex flex-col gap-1 text-left">
        <label className="text-xs font-medium text-gray-700 text-left">
          {label}
        </label>
        <div {...otherProps}>{children}</div>
      </div>
    </>
  );
}

export default Label;
